import { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { IListPerfilFiscal } from '../../../../Pages/Cadastro/CadPerfilFiscal';
import LayoutFilter from '../../../data/LayoutFilter';
import ReactSelect from '../../../data/reactSelect';
import LayoutTable from '../../../data/LayoutTable';
import DataTable from 'react-data-table-component';
import tableStyleDefault from '../../../../Services/tableStyleDefault';
import { FaEdit, FaRegTrashAlt } from 'react-icons/fa';
import { IPerfilFiscal } from '../interface/IPerfilFiscal';
import { ToastContainer } from 'react-toastify';
import { sortByCreated } from '../../../../Services/sortByCreated';
import api from '../../../../Services/api';
import globals from './../../../../Globals.json';
import { notify, notifyError } from '../../../notify/notify-component';
import GetEndPoint from '../../../../Services/GetEndPoint';
import CustomLoader from '../../../data/customLoader';
import { useAppSelector } from '../../../../redux/store';
import * as S from './styled';
import ReactSelectAsync from '../../../data/reactSelectAsync';
import ModalBootstrap from '../../../data/Modal';
import { useQueryFetchPages } from '../../../../apiQuery/useQueryFetchPages';
import { paginationOptions } from '../../../data/PagineteInfo';
import Loading from '../../../Loading/Loading';
import { useFetchById } from '../../../../apiQuery/useFetchById';
import { useDeleteData } from '../../../../apiQuery/useDeleteData';
import { queryClient } from '../../../../apiQuery/queryClient';
import NcmSelect from '../../../data/NcmSelect';

export default function ListaPerfilFiscal({
  OnAddNewCli,
  title,
  onEditItem,
}: IListPerfilFiscal) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const [page, setPage] = useState(1);

  const {
    data: ncms,
    isLoading: isLoadingNcms,
    isError: isErrorNcms,
  } = useQueryFetchPages<any>(['ncms'], `${globals.api.taxes}/ncms`, {
    queryParams: {
      store_id: storeMe?.storeActive?.id,
      paginate: false,
    },
  });
  const {
    data: taxProfiles,
    isLoading: isLoadingTaxProfile,
    isError: isErrorTaxProfile,
  } = useQueryFetchPages<any>(['taxProfile'], `${globals.api.taxProfile}`, {
    queryParams: {
      store_id: storeMe?.storeActive?.id,
      paginate: false,
    },
  });
  const {
    data: cests,
    isLoading: isLoadingCests,
    isError: isErrorCests,
  } = useQueryFetchPages<any>(['cests'], `${globals.api.taxes}/cests`, {
    queryParams: {
      paginate: false,
    },
  });
  const [profileName, setProfileName] = useState<string>('');
  const [cest, setCest] = useState<number>(0);
  const [ncm, setNcm] = useState<number | undefined>(0);
  const {
    data: taxProfilesFilter,
    isLoading: isLoadingTaxProfileFilter,
    isError: isErrorTaxProfileFilter,
  } = useQueryFetchPages<any>(['taxProfile'], `${globals.api.taxProfile}`, {
    page: page,

    queryParams: {
      store_id: storeMe?.storeActive?.id,
      ...(profileName && { 'filter[tax_profile_name]=': profileName }),
      ...(cest && { 'filter[cest_id]=': cest }),
      ...(ncm && { 'filter[ncm_id]=': ncm }),
    },
  });

  const [profileNameId, setProfileNameId] = useState<number>(0);

  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [modalDel, setModalDel] = useState<boolean>(false);
  const [uuidDelete, setUuidDelete] = useState<string>('');
  const [uuidPerfilFiscal, setUuidPerfilFiscal] = useState<string>('');
  const {
    data: taxProfileByUuidFetch,
    isLoading: isLoadingProfileById,
    isError: isErrorProductById,
  } = useFetchById<any>(
    'taxProfile',
    `${globals.api.taxProfile}`,
    uuidPerfilFiscal,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
      },
    }
  );
  const columns = [
    {
      name: 'Nome',
      center: false,
      sortable: true,
      grow: 2,
      selector: (row: any) => row.tax_profile_name,
    },
    {
      name: 'CEST',
      center: true,
      grow: 1,
      selector: (row: any) => row.relationships?.cest?.cest_code ?? '---',
    },
    {
      name: 'NCM',
      center: true,
      grow: 1,
      selector: (row: any) => row?.relationships?.ncm?.codigo ?? '---',
    },

    {
      name: 'Ação',
      cell: (row: any) => (
        <div className="actions flex gap-3">
          <FaEdit
            size={16}
            data-toggle="tooltip"
            data-placement="top"
            title="Editar"
            className="action"
            onClick={() => setUuidPerfilFiscal(row?.uuid)}
            color="8e8d8d"
          />
          <FaRegTrashAlt
            data-toggle="tooltip"
            data-placement="top"
            title="Deletar"
            className="action"
            onClick={() => handleModalDelete(row)}
            size={14}
            color="red"
          />
        </div>
      ),
      button: true,
    },
  ];

  const handleAdd = () => {
    OnAddNewCli(true);
  };

  const onClickOpenFilter = () => {
    setOpenFilter(!openFilter);
  };

  const handleModalDelete = (row: any) => {
    setModalDel(true);
    setUuidDelete(row.uuid);
  };

  const deleteData = useDeleteData(['taxProfile']);
  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    //setPerPage(newPerPage);
    setPage(page);
  };
  const handleDelete = () => {
    deleteData.mutate(
      {
        endpoint: globals.api.taxProfile,
        id: uuidDelete,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey[0] === 'taxProfile',
          });
          setModalDel(false);
        },
      }
    );
  };

  useEffect(() => {
    if (isLoadingProfileById) return;
    const setUuidProduct = (row: any) => {
      if (typeof onEditItem === 'function' && row !== undefined) {
        onEditItem(taxProfileByUuidFetch?.data);
      }
    };

    uuidPerfilFiscal && setUuidProduct(uuidPerfilFiscal);
  }, [isLoadingProfileById, taxProfileByUuidFetch?.data, uuidPerfilFiscal]);

  if (isLoadingProfileById) return <Loading />;

  return (
    <>
      <ModalBootstrap
        state={modalDel}
        setState={setModalDel}
        text={'Tem certeza de que deseja excluir?'}
        handleAction={handleDelete}
      />
      <LayoutFilter
        title={title}
        onClickAdd={handleAdd}
        onClickOpenFilter={onClickOpenFilter}
        openFilter={openFilter}
      >
        <S.Wrapper>
          {openFilter && (
            <div className="min-screen">
              <ReactSelect
                label="Perfil fiscal"
                isClearable={true}
                placeholder="Perfil fical"
                options={taxProfiles?.data?.map((item: any) => ({
                  value: item.id,
                  label: item.tax_profile_name,
                  store_id: item.store_id,
                }))}
                state={profileNameId}
                setState={setProfileName}
                onChange={(e: any) => {
                  setProfileName(e?.label);
                  setProfileNameId(e?.value);
                }}
                isLoading={isLoadingTaxProfile}
              />

              <ReactSelect
                label="CEST"
                isClearable={true}
                placeholder={'Cest'}
                options={cests?.data?.map((item: any) => ({
                  value: item?.id,
                  label: item?.cest_code,
                }))}
                state={cest}
                setState={setCest}
                isLoading={isLoadingCests}
              />

              <NcmSelect
                label="NCM"
                state={ncm}
                setState={setNcm}
                placeholder="Pesquise seu NCM"
              />
            </div>
          )}

          <div className="max-screen">
            <ReactSelect
              label="Perfil fiscal"
              isClearable={true}
              placeholder="Perfil fical"
              options={taxProfiles?.data?.map((item: any) => ({
                value: item.id,
                label: item.tax_profile_name,
                store_id: item.store_id,
              }))}
              state={profileNameId}
              setState={setProfileName}
              onChange={(e: any) => {
                setProfileName(e?.label);
                setProfileNameId(e?.value);
              }}
              isLoading={isLoadingTaxProfile}
            />

            <ReactSelect
              label="CEST"
              isClearable={true}
              placeholder={'Cest'}
              options={cests?.data?.map((item: any) => ({
                value: item?.id,
                label: item?.cest_code,
              }))}
              state={cest}
              setState={setCest}
              isLoading={isLoadingCests}
            />

            <NcmSelect
              label="NCM"
              state={ncm}
              setState={setNcm}
              placeholder="Pesquise seu NCM"
            />
          </div>
        </S.Wrapper>
      </LayoutFilter>

      <LayoutTable>
        <DataTable
          columns={columns}
          data={taxProfilesFilter?.data || []}
          striped
          pagination
          paginationServer
          paginationTotalRows={taxProfilesFilter?.meta?.total}
          paginationDefaultPage={1}
          paginationPerPage={15}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          customStyles={tableStyleDefault}
          paginationComponentOptions={paginationOptions}
          progressPending={isLoadingTaxProfileFilter}
          progressComponent={<CustomLoader />}
          noDataComponent="Nenhuma informação foi encontrada."
        />
      </LayoutTable>
    </>
  );
}
